import React from "react";
import { Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import ProductCardComponent from "../ProductCard/ProductCardComponent";
import ShimmerScreen from "../../Layouts/ShimmerScreen";
import { useTranslation } from "react-i18next";

const CommonComponentEntity = (props) => {
  const { isLoading, newCardData, heading, subHeading, viewAllAction, type } =
    props;
  let navigate = useNavigate();
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const keyword = params.get("keyword");
  const { t } = useTranslation();
  return (
    <>
      {newCardData.length > 0 ? (
        <>
          <section
            className={`subscription-course-section home-page-${type}-grid`}
          >
            <div className="container">
              <div className="row">
                <div className="col-md-8 col-12">
                  <div className="subscriptions-row">
                    {newCardData[0].isLoading ? (
                      <h3 className="subs-course-title">
                        <ShimmerScreen
                          case="rect"
                          height="2rem"
                          width="30rem"
                        />
                      </h3>
                    ) : (
                      <h3 className="subs-course-title">{heading}</h3>
                    )}
                    {true ? (
                      ""
                    ) : newCardData[0]?.isLoading ? (
                      <span className="subscriptions-subhead">
                        <ShimmerScreen
                          case="rect"
                          height="1rem"
                          width="10rem"
                        />
                      </span>
                    ) : (
                      <span className="subscriptions-subhead">
                        {subHeading}
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-md-4 col-12 text-md-end">
                  {newCardData[0]?.isLoading ? (
                    <button type="button" className="view-all-btn">
                      <ShimmerScreen case="rect" height="3rem" width="7rem" />
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="view-all-btn"
                      onClick={() => navigate(viewAllAction)}
                    >
                      {t("viewAll")}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                          stroke="#415385"
                          strokeWidth="1.66667"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                    </button>
                  )}
                </div>
              </div>
              <div className="row coursecard-row videosection-cont">
                {newCardData.length === 0
                  ? ""
                  : newCardData.map((video, i) => {
                      if (i < 3 || keyword) {
                        return (
                          <ProductCardComponent
                            {...video}
                            key={`video-${i + 1}`}
                          />
                        );
                      }
                    })}
              </div>
            </div>
          </section>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default CommonComponentEntity;
